import { Icon } from '@components/icon/Icon';
import { getIconNameForTableTag } from '@shared/floorPlans/tableTagOptions';
import { Carousel } from '../../shared/components/carousel/Carousel';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './TableSelectedDetails.scss';
import { useTableSelectedPresentation } from '../hooks/useTableSelectedPresentation';

export const TableSelectedDetails = () => {
  const {
    selectedTablePhotoSlides,
    selectedTableDescription,
    selectedTableTags,
    carouselRemountKey,
  } = useTableSelectedPresentation();

  if (selectedTablePhotoSlides.length === 0) {
    return null;
  }

  return (
    <div
      className={styles.tablePhotoSection}
      data-testid="selected-table-photo-section"
    >
      <div
        className={styles.tablePhotoCarousel}
        data-testid="selected-table-photo-carousel"
      >
        <Carousel
          key={carouselRemountKey}
          variant="compact"
          compactSizing="fill"
          slides={selectedTablePhotoSlides}
          showArrowNavigation={false}
          autoAdvance={selectedTablePhotoSlides.length >= 2}
          autoAdvanceIntervalMs={3000}
          expandToModal
          expandModalTriggerLabel="View full table photos"
          fullWidthImageAlt="Table photo"
        />
      </div>
      {selectedTableDescription ? (
        <p
          className={cx(typography.c3_20, styles.tableDescription)}
          data-testid="selected-table-description"
        >
          {selectedTableDescription}
        </p>
      ) : null}
      {selectedTableTags.length > 0 ? (
        <ul className={styles.tableTagList} data-testid="selected-table-tags">
          {selectedTableTags.map((tag, index) => (
            <li key={`${tag}-${index}`} className={styles.tableTag}>
              <Icon
                name={getIconNameForTableTag(tag)}
                className={styles.tableTagCategoryIcon}
                aria-hidden
              />
              <span className={styles.tableTagLabel}>{tag}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};
